var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/undo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6086 15.8834H5.94189C5.60023 15.8834 5.31689 15.6 5.31689 15.2584C5.31689 14.9167 5.60023 14.6334 5.94189 14.6334H12.6086C14.5586 14.6334 16.1502 13.0417 16.1502 11.0917C16.1502 9.14172 14.5586 7.55005 12.6086 7.55005H3.44189C3.10023 7.55005 2.81689 7.26672 2.81689 6.92505C2.81689 6.58338 3.10023 6.30005 3.44189 6.30005H12.6086C15.2502 6.30005 17.4002 8.45005 17.4002 11.0917C17.4002 13.7334 15.2502 15.8834 12.6086 15.8834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.3583 9.63336C5.19997 9.63336 5.04163 9.57503 4.91663 9.45003L2.7833 7.31669C2.54163 7.07502 2.54163 6.67502 2.7833 6.43336L4.91663 4.30002C5.1583 4.05836 5.5583 4.05836 5.79997 4.30002C6.04163 4.54169 6.04163 4.94169 5.79997 5.18336L4.1083 6.87502L5.79997 8.56669C6.04163 8.80836 6.04163 9.20836 5.79997 9.45003C5.6833 9.57503 5.51663 9.63336 5.3583 9.63336Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.93dee600dcb9eae5592e92638db7f7d5.svg";
export { ForwardRef as ReactComponent };